<div
  class="card-buttons"
  [ngClass]="{
    'size-small': sizeSmall,
  }"
>
  <ion-button
    class="card-buttons--grow"
    [size]="size"
    color="success"
    fill="solid"
    libClickStopPropagation
    (click)="showAlertAcceptPrice()"
  >
    <ion-icon
      src="../assets/material-symbols/task_alt_24dp_FILL0_wght400_GRAD0_opsz24.svg"
      slot="start"
    ></ion-icon>
    @if (sizeSmall) {
      Aceptar
    } @else {
      Aceptar precio
    }
  </ion-button>
  <ion-button
    class="card-buttons--min"
    shape="round"
    [size]="size"
    color="danger"
    fill="outline"
    libClickStopPropagation
    (click)="showAlertRejectPrice()"
  >
    <ion-icon
      src="../assets/material-symbols/close_24dp_FILL0_wght400_GRAD0_opsz24.svg"
      [slot]="sizeSmall ? 'icon-only' : 'start'"
    ></ion-icon>
    @if (!sizeSmall) {
      Rechazar
    }
  </ion-button>
</div>
